import { render } from "./AddNewBookForm.vue?vue&type=template&id=712229dd&scoped=true"
import script from "./AddNewBookForm.vue?vue&type=script&lang=js"
export * from "./AddNewBookForm.vue?vue&type=script&lang=js"

import "./AddNewBookForm.vue?vue&type=style&index=0&id=712229dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712229dd"]])

export default __exports__